/* THEONE back in stock
   When the chosen size is sold out the buy button is dead and the visitor
   leaves with nothing. This moves a quiet waiting list into its place and
   records which ring and which size, so the restock email can be exact.

   The panel is Shopify's own {% form 'customer' %}, rendered by
   tl-bis-form.liquid and relocated here. It has to be the real form and it
   has to be submitted by a real click: a scripted submit, or a hand rolled
   POST to /contact, is refused with "Missing CAPTCHA token". */
(function () {
  'use strict';
  if (window.__tlBis) return;
  window.__tlBis = true;

  var COPY = {
    en: {
      eyebrow: 'Gone for now',
      ask: function (s) { return s ? 'Tell me when size <b>' + s + '</b> comes back.' : 'Tell me when this ring comes back.'; },
      ph: 'Your email',
      note: 'One email, about this ring only.',
      ok: 'You are on the list.',
      oksub: function (s) { return s ? 'We write the moment size ' + s + ' is back.' : 'We write the moment it is back.'; }
    },
    de: {
      eyebrow: 'Gerade vergriffen',
      ask: function (s) { return s ? 'Sag mir, wenn Größe <b>' + s + '</b> zurück ist.' : 'Sag mir, wenn dieser Ring zurück ist.'; },
      ph: 'Deine E-Mail',
      note: 'Eine E-Mail, nur zu diesem Ring.',
      ok: 'Du stehst auf der Liste.',
      oksub: function (s) { return s ? 'Wir schreiben, sobald Größe ' + s + ' wieder da ist.' : 'Wir schreiben, sobald er wieder da ist.'; }
    },
    it: {
      eyebrow: 'Esaurito per ora',
      ask: function (s) { return s ? 'Avvisami quando torna la misura <b>' + s + '</b>.' : 'Avvisami quando torna questo anello.'; },
      ph: 'La tua email',
      note: 'Una sola email, solo per questo anello.',
      ok: 'Sei in lista.',
      oksub: function (s) { return s ? 'Ti scriviamo appena la misura ' + s + ' torna disponibile.' : 'Ti scriviamo appena torna disponibile.'; }
    }
  };

  var moved = false;

  function copy() {
    var l = (document.documentElement.lang || '').toLowerCase();
    if (l.indexOf('de') === 0) return COPY.de;
    if (l.indexOf('it') === 0) return COPY.it;
    return COPY.en;
  }
  function root() { return document.getElementById('tlbis-root'); }
  function main() { return document.querySelector('main[data-template="product"]'); }
  function buyBlock() {
    var m = main(); if (!m) return null;
    return m.querySelector('[class*="buy-buttons-block"]');
  }
  function atc() {
    var m = main(); if (!m) return null;
    return m.querySelector('form[data-type="add-to-cart-form"] .add-to-cart-button');
  }
  function isSoldOut() {
    var b = atc();
    if (!b) return false;
    if (b.disabled) return true;
    return /sold\s*out|ausverkauft|esaurito|non disponibile/i.test(b.textContent || '');
  }
  function size() {
    var m = main(); if (!m) return '';
    var r = m.querySelector('variant-picker input[type="radio"]:checked');
    return r ? (r.value || '').trim() : '';
  }
  function title() {
    var m = main(); if (!m) return '';
    var h = m.querySelector('h1');
    return h ? h.textContent.trim().replace(/\s+/g, ' ') : '';
  }
  function variantId() {
    var m = main(); if (!m) return '';
    var i = m.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
    return i ? i.value : '';
  }
  function label(el, key, txt, html) {
    var n = el.querySelector('[data-bis="' + key + '"]');
    if (!n) return;
    if (html) n.innerHTML = txt; else n.textContent = txt;
  }

  function paint() {
    var r = root(); if (!r) return;
    var c = copy(), s = size();
    r.setAttribute('data-size', s);
    label(r, 'eyebrow', c.eyebrow);
    label(r, 'line', c.ask(s), true);
    label(r, 'note', c.note);
    var mail = document.getElementById('tlbis-email');
    if (mail) mail.placeholder = c.ph;
  }

  function showSuccess(s) {
    var r = root(); if (!r) return;
    var c = copy();
    r.innerHTML = '';
    var box = document.createElement('div');
    box.className = 'tlbis';
    box.innerHTML = '<span class="tlbis__eyebrow"></span><p class="tlbis__ok"></p><p class="tlbis__oksub"></p>';
    box.querySelector('.tlbis__eyebrow').textContent = c.eyebrow;
    box.querySelector('.tlbis__ok').textContent = c.ok;
    box.querySelector('.tlbis__oksub').textContent = c.oksub(s);
    r.appendChild(box);
    r.setAttribute('data-done', '1');
    r.hidden = false;
  }

  function place() {
    var r = root(); if (!r || moved) return;
    var a = buyBlock();
    if (!a) { var b = atc(); a = b ? b.closest('form') : null; }
    if (!a) return;
    a.insertAdjacentElement('afterend', r);
    moved = true;
  }

  function ensure() {
    var r = root(); if (!r) return;
    if (!main()) { r.hidden = true; return; }
    place();
    if (r.getAttribute('data-done')) { r.hidden = false; return; }
    if (!isSoldOut()) { r.hidden = true; return; }
    paint();
    r.hidden = false;
  }

  function wire() {
    var f = document.getElementById('tlbis-form');
    if (!f || f.__bis) return;
    f.__bis = true;
    /* Never submit in code. Stamp the tags and let the real click through,
       so Shopify can attach its CAPTCHA token. */
    f.addEventListener('submit', function () {
      var t = document.getElementById('tlbis-tags');
      var s = (root() && root().getAttribute('data-size')) || '';
      if (t) t.value = ['back-in-stock', title(), s ? 'size ' + s : '', variantId()].filter(Boolean).join(', ');
      try { sessionStorage.setItem('tlbis-pending', s); } catch (e) {}
    });
  }

  /* Shopify's flag goes true for every customer form on the page after any
     customer post, so require our own pending flag as well. */
  function returned() {
    var f = document.getElementById('tlbis-posted');
    var ok = (f && f.value === '1') || location.search.indexOf('customer_posted=true') !== -1;
    if (!ok) return null;
    var p = null;
    try { p = sessionStorage.getItem('tlbis-pending'); } catch (e) {}
    if (p === null) return null;
    try { sessionStorage.removeItem('tlbis-pending'); } catch (e) {}
    return p;
  }

  function init() {
    wire();
    var back = returned();
    if (back !== null) { place(); showSuccess(back); return; }
    ensure();
    var m = main();
    if (!m || !('MutationObserver' in window)) return;
    var pending = 0;
    var mo = new MutationObserver(function () {
      if (pending) return;
      pending = 1;
      setTimeout(function () { pending = 0; ensure(); }, 60);
    });
    mo.observe(m, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  setTimeout(function () {
    var r = root();
    if (r && !r.getAttribute('data-done')) ensure();
  }, 1200);
})();
